import React, { Component } from 'react';
import cookie from 'react-cookies';
import { useUnsavedChanges } from './UnsavedChangesContext';

class SessionUser extends Component {

    constructor(props){
        super(props);
        this.state = {
            security: cookie.load('user'),
            loading: false,
            logout: false,
        } 
      }

    handleLogout(){
        localStorage.clear();
        localStorage.setItem("usermenu", null);
        localStorage.setItem("user", null);
        cookie.remove('usermenu', { path: '/' });
        cookie.remove('user', { path: '/' });
        window.location.href='/';
    }

    handleLogoutClick = (event) => {
        event.preventDefault();
        const doLogout = () => this.handleLogout();
        if (this.props.requestNavigation) {
            this.props.requestNavigation(doLogout);
        } else {
            doLogout();
        }
    }

    render() {
        return (
            <div className="btnSesion">
              <span>{this.state.security.sUsuNombre}</span>
              <a href="" onClick={this.handleLogoutClick}/>
            </div>
        )
    }
}

// Wrapper funcional: permite usar el hook useUnsavedChanges y pasarlo como prop
// a SessionUser (que sigue siendo un componente de clase, sin tocar su lógica interna).
const SessionUserWithGuard = (props) => {
    const { requestNavigation } = useUnsavedChanges();
    return <SessionUser {...props} requestNavigation={requestNavigation} />;
};

export default SessionUserWithGuard;
